var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aplayer-lrc"},[_c('div',{staticClass:"aplayer-lrc-contents",style:(_vm.transformStyle)},_vm._l((_vm.lrcLines),function(line,index){return _c('p',{key:index,class:{ 'aplayer-lrc-current': index === _vm.currentLineIndex }},[_vm._v("\n      "+_vm._s(line[1])+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a0dd4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/aplayer/components/aplayer-lrc.vue
// module id = wjqo
// module chunks = 30